import { render, staticRenderFns } from "./ProblemDialog.vue?vue&type=template&id=1e35014e&scoped=true"
import script from "./ProblemDialog.vue?vue&type=script&lang=js"
export * from "./ProblemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35014e",
  null
  
)

export default component.exports